<template>
  <div class="container-fluid">
    <div class="contents member_info">
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-0 border-bottom border-top-dgray">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{ $t("title.common.id") }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p>{{ form.id }}</p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.common.nickname")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p>{{ form.nickname }}</p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{ $t("title.common.name") }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p>{{ form.name }}</p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.common.gender")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p>{{ form.gender | gender }}</p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.membership.recent_playing_date")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p class="text-date">
                {{ form.timezone_lastdate | dateformat }}
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.membership.join_date")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p class="text-date">
                {{ form.timezone_joindate | dateformat }}
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{ $t("title.common.email") }}</label>
            </div>
            <div class="col-7 col-lg-9 text-break">
              <p>{{ form.email }}</p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.membership.locker_no")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <p>
                {{ form.lockerno }}
                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  @click="showLockerModal"
                >
                  {{ $t("page.membership.choose_locker") }}
                </button>
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.membership.locker_period")
              }}</label>
            </div>
            <div class="col-7 col-lg-9 date_range">
              <input
                type="date"
                class="form-control-lg"
                v-model="form.lockersdate"
              />
              <input
                type="date"
                class="form-control-lg"
                v-model="form.lockeredate"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.common.handicap")
              }}</label>
            </div>
            <div class="col-7 col-lg-9">
              {{ hc_au(form.handicap_index) || "Unregistered" }}
            </div>
          </div>
          <!-- <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">Bucks</label>
            </div>
            <div class="col-7 col-lg-9">
              <p class="point">
                <router-link
                  :to="{
                    name: 'PointList',
                    query: { searchtext: form.nickname },
                  }"
                  class="more point"
                >
                  {{ form.point | comma }}B</router-link
                >
              </p>
            </div>
          </div> -->
          <div class="row g-0 border-bottom">
            <div class="col-5 col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{ $t("title.common.memo") }}</label>
            </div>
            <div class="col-7 col-lg-9">
              <textarea
                cols="30"
                rows="10"
                :placeholder="$t('title.common.memo')"
                v-model="form.memo"
              ></textarea>
            </div>
          </div>
          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              aria-label="목록"
              @click="$router.push({ name: 'MemberList' })"
              >{{ $t("button.common.list") }}
            </b-button>
            <b-button
              size="xl"
              variant="primary"
              aria-label="저장"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </ValidationObserver>
    </div>

    <b-modal
      id="modal-locker"
      ref="modal-locker"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
      @ok="lockerNoChange"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("menu.membership.locker") }}
          <small class="fs-6 text-gray"
            >({{ $t("title.common.total") }} {{ lockerinfocnt }})</small
          >
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>

      <div class="locker_title row g-0">
        <div class="col-lg d-flex align-items-stretch bg-gray border-right">
          <h6 class="my-auto flex-fill py-2">
            {{ $t("title.membership.locker_status") }}
          </h6>
        </div>
        <div
          class="col-lg d-flex flex-wrap justify-content-evenly align-items-stretch border-right"
        >
          <div class="flex-fill my-auto">
            <span class="available"></span>
            <p>{{ $t("title.membership.available") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="unavailable"></span>
            <p>{{ $t("title.membership.unavailable") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="expired"></span>
            <p>{{ $t("title.membership.expired") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="using"></span>
            <p>{{ $t("title.membership.using") }}</p>
          </div>
        </div>

        <div class="col-lg">
          <a @click="prev_pageno">{{ $t("button.membership.prev") }}</a>
          <select class="" v-model="pageno" @change="change_pageno">
            <option v-for="(item, idx) in pagenoOptCnt" :key="idx">
              {{ item }}
            </option>
          </select>
          <a @click="next_pageno">{{ $t("button.membership.next") }}</a>
        </div>
      </div>
      <!-- // locker_title -->

      <div class="locker-room-wrapper mt-4">
        <div
          class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-2"
          v-if="lockerinfo.length > 0"
        >
          <div class="col" v-for="(item, idx) in lockerinfo" :key="idx">
            <div
              class="locker-room"
              :class="{
                using: lockerModalListClass(lockerinfo[idx]) === 1,
                expired: lockerModalListClass(lockerinfo[idx]) === 2,
                unavailable: lockerModalListClass(lockerinfo[idx]) === 3,
                lockerBg: lockerinfo[idx].lockerBg,
              }"
              @click="lockerSelect(idx)"
            >
              <div
                v-html="lockerShowText(idx)"
                :class="{
                  in:
                    lockerStatus(lockerinfo[idx]) === 1 ||
                    lockerStatus(lockerinfo[idx]) === 2 ||
                    lockerStatus(lockerinfo[idx]) === 3,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.done')"
          @click="ok()"
          >{{ $t("button.common.done") }}</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "@/components/common/validations/inputbox";
import commonDatePicker from "@/components/common/datepicker/Picker";
import ax from "@/api/member";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MemberView",
  components: {
    ValidationObserver,
    InputWithValidation,
  },
  data() {
    return {
      form: {
        id: null,
        nickname: null,
        name: null,
        gender: null,
        lastdate: null,
        regdate: null,
        email: null,
        lockerno: null,
        lockersdate: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        lockeredate: this.$dayjs(new Date()).format("YYYY-MM-DD"),

        handicap_index: null,
        memo: null,
      },
      lockerinfocnt: 0,
      lockerinfo: [
        {
          no: null,
          lockerno: null,
          lockerstatus: null,
        },
      ],
      lockerSelected: null,
      pageno: 1,
      pagesize: 30,
      pagenoOptCnt: 0,
      lockersize: 30,
    };
  },
  created() {},
  mounted() {
    if (this.$route.params.playerno) {
      ax.memberGet(this.$route.params.playerno, (response) => {
        this.form = response;
        if (response.timezone_lockersdate)
          this.form.lockersdate = this.$dayjs(
            response.timezone_lockersdate
          ).format("YYYY-MM-DD");
        if (response.timezone_lockeredate)
          this.form.lockeredate = this.$dayjs(
            response.timezone_lockeredate
          ).format("YYYY-MM-DD");
      });
    }
  },
  watch: {
    pageno: function () {
      ax.lockerGet(this.$route.params.playerno, this.pageno, (response) => {
        // this.lockerinfocnt = response.lockerinfocnt
        // this.lockerinfo = response.lockerinfo
        // this.pagenoOptCnt = Math.ceil(response.lockerinfocnt / this.pagesize)
        // this.change_locker_num()

        this.lockerinfo = [];
        this.lockerinfocnt = response.lockerinfocnt;
        for (let i = 0; i < response.lockerinfo.length; i++) {
          // 배경색상 입히기
          response.lockerinfo[i].lockerBg =
            this.form.lockerno === parseInt(response.lockerinfo[i].lockerno);
          this.lockerinfo.push(response.lockerinfo[i]);
        }
        // 페이지수 계산
        this.pagenoOptCnt = Math.ceil(response.lockerinfocnt / this.pagesize);
        this.change_locker_num();
      });
    },
  },
  methods: {
    lockerStatus(o) {
      if (o) {
        return parseInt(o.lockerstatus);
      }
    },
    lockerShowText(idx) {
      if (this.lockerinfo[idx]) {
        if (
          parseInt(this.lockerinfo[idx].lockerstatus) === 1 ||
          parseInt(this.lockerinfo[idx].lockerstatus) === 2
        ) {
          return (
            "<div>" +
            '<span class="number">' +
            this.lockerinfo[idx].lockerno +
            "</span>" +
            '<span class="text-nickname">' +
            this.lockerinfo[idx].nickname +
            "</span>" +
            "</div>" +
            '<div class="text-date">' +
            this.$dayjs(this.lockerinfo[idx].timezone_enddate).format(
              "YYYY-MM-DD"
            ) +
            "</div>"
          );
        }
      }
      return this.lockerinfo[idx].lockerno;
    },
    change_pageno() {
      this.$router.push({ query: { pageno: this.pageno } });
    },
    prev_pageno() {
      if (this.pageno > 1) {
        this.pageno = parseInt(this.pageno) - 1;
        this.$router.push({ query: { pageno: this.pageno } });
      }
    },
    next_pageno() {
      if (this.pageno < this.pagenoOptCnt) {
        this.pageno = parseInt(this.pageno) + 1;
        this.$router.push({ query: { pageno: this.pageno } });
      }
    },
    onSubmit() {
      // alert(this.form.lockerno);
      // alert(this.form.lockersdate);
      if (this.form.lockerno !== null) {
        // alert('Please select a locker No.');
        // return false;
        // } else {
        if (this.form.lockersdate === "Invalid Date") {
          alert(this.$i18n.t("alert.member.select_startdate_of_locker"));
          return false;
        }
        if (this.form.lockeredate === "Invalid Date") {
          alert(this.$i18n.t("alert.member.select_end_of_locker"));
          return false;
        }
      }
      this.memberSave();
    },
    memberSave() {
      ax.memberSave(this.$route.params.playerno, this.form, (flag, data) => {
        // alert(flag);
        alert(data.message);
        if (flag) {
          location.reload();
        }
      });
    },
    cancel() {
      this.$router.push({ path: "/member", query: this.$route.query });
    },
    startDateChange(v) {
      this.form.lockersdate = v;
    },
    endDateChange(v) {
      this.form.lockeredate = v;
    },

    showLockerModal() {
      ax.lockerGet(this.$route.params.playerno, this.pageno, (response) => {
        this.lockerinfo = [];
        this.lockerinfocnt = response.lockerinfocnt;
        for (let i = 0; i < response.lockerinfo.length; i++) {
          // 배경색상 입히기
          response.lockerinfo[i].lockerBg =
            this.form.lockerno === parseInt(response.lockerinfo[i].lockerno);
          this.lockerinfo.push(response.lockerinfo[i]);
        }
        // 페이지수 계산
        this.pagenoOptCnt = Math.ceil(response.lockerinfocnt / this.pagesize);
        this.change_locker_num();
      });
      //this.$refs["modal-locker"].modalOuterStyle.zIndex = 9999;
      this.$refs["modal-locker"].show();
    },
    lockerSelect(idx) {
      // 선택가능 하다면
      if (this.lockerinfo[idx].lockerstatus !== "1") {
        this.lockerSelected = this.lockerinfo[idx].lockerno;
        // 전체 박스 bg-info 제거
        for (let i in this.lockerinfo) {
          this.lockerinfo[i].lockerBg = false;
        }
        // 선택한거 bg-info 넣기
        this.lockerinfo[idx].lockerBg = true;
      }
    },
    lockerNoChange() {
      this.form.lockerno = this.lockerSelected;
    },
    lockerModalListClass(o) {
      if (o) {
        return parseInt(o.lockerstatus);
        //return o.lockerstatus === '1'
      }
    },
    change_locker_num() {
      this.lockersize = this.pageno * this.pagesize;
      if (this.lockersize > this.lockerinfocnt) {
        this.lockersize = parseInt(this.lockerinfocnt);
      }
    },
  },
  mixins: [myMixin],
};
</script>
